// An invoice's PDF, downloaded with the person's sign-in (GET /api/invoices/:id/pdf). Moved here from
// InvoicingDashboard so the chat's PDF card downloads it the same way (one way in). A failed download
// must not look like it worked: the status and the content type are both checked.
//
// Returns null on success, or a message to show. It does not toast: the caller decides where to say it.
import { api } from '../api/client';
import { messageFromError } from './apiError';

export async function downloadInvoicePdf(invoice) {
  try {
    const res = await api(`/api/invoices/${invoice.id}/pdf`);
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      return body.error || "That did not download. Please try again.";
    }
    const blob = await res.blob();
    if (blob.type && !blob.type.includes("pdf")) return "That did not download. Please try again.";
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${String(invoice.number || "invoice").replace(/[^a-z0-9]/gi, "_")}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoked, or every download leaks the whole PDF for the life of the tab.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return null;
  } catch (err) {
    return messageFromError(err, "That did not download. Please try again.");
  }
}
